import SurveyForm from './survey/SurveyForm';

interface Props {
  isAffiliate?: boolean;
}

// 円の共通スタイル
const circleBase: React.CSSProperties = {
  width: '104px',
  height: '104px',
  borderRadius: '50%',
  background: 'rgba(250, 124, 158, 0.9)',
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '8px',
  border: '2px solid rgba(255,255,255,0.6)',
  flexShrink: 0,
  boxSizing: 'border-box',
  gap: '2px',
};

// 円内テキスト — 全て同じfontSize: 11.5px
const circleText: React.CSSProperties = {
  fontSize: '11.5px',
  lineHeight: 1.45,
  fontWeight: 700,
};

const emStyle: React.CSSProperties = {
  fontSize: '11.5px',
  fontWeight: 900,
  textDecoration: 'underline',
  textDecorationThickness: '1.5px',
};

// タイトル各行の白背景スタイル
const lineBg = (color: string, fontSize: string, fontWeight = 700): React.CSSProperties => ({
  display: 'inline-block',
  background: 'rgba(255,255,255,0.92)',
  borderRadius: '4px',
  padding: '3px 10px',
  fontSize,
  color,
  fontWeight,
  lineHeight: 1.3,
  marginBottom: '4px',
  whiteSpace: 'nowrap',
});

export default function MainVisual({ isAffiliate = false }: Props) {
  return (
    <section
      className="main-visual-bg"
      data-track-view="view_hero"
      data-element-name="hero_main_visual"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        paddingTop: '120px',
        paddingBottom: '80px',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '480px',
          padding: '0 16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '18px',
        }}
      >
        {/* タイトル — 各行ごとに白背景 */}
        <h1
          style={{
            fontFamily: "'Zen Maru Gothic', sans-serif",
            alignSelf: 'flex-start',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          {/* 看護師の転職なら（ピンク背景タグ） */}
          <span
            style={{
              display: 'inline-block',
              background: '#fa7c9e',
              borderRadius: '4px',
              padding: '2px 10px',
              fontSize: '12px',
              color: 'white',
              fontWeight: 700,
              marginBottom: '4px',
              whiteSpace: 'nowrap',
            }}
          >
            看護師の転職なら
          </span>
          {/* ニジ看護転職 */}
          <span style={lineBg('#fa7c9e', '26px', 900)}>ニジ看護転職</span>
          {/* ひとりひとりを */}
          <span style={lineBg('#444', '15px')}>ひとりひとりを</span>
          {/* 親身にサポート */}
          <span style={lineBg('#fa7c9e', '15px', 700)}>親身にサポート</span>
        </h1>

        {/* Feature Circles — 中央揃え */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            width: '100%',
          }}
        >
          {/* Circle 1: 元看護師を強調 */}
          <div style={circleBase}>
            <span style={emStyle}>元看護師</span>
            <span style={circleText}>× 女性ADが</span>
            <span style={{ ...circleText, fontWeight: 900 }}>親身に対応</span>
          </div>

          {/* Circle 2: LINE */}
          <div style={circleBase}>
            <span style={{ ...circleText, fontWeight: 900 }}>LINE</span>
            <span style={circleText}>すぐに相談</span>
            <span style={circleText}>完全無料</span>
          </div>

          {/* Circle 3: 非公開を強調 */}
          <div style={circleBase}>
            <span style={emStyle}>非公開</span>
            <span style={circleText}>高待遇求人</span>
            <span style={{ ...circleText, fontWeight: 900 }}>多数紹介</span>
          </div>
        </div>

        {/* Survey Form Box */}
        <div style={{ width: '100%', marginTop: '8px' }}>
          <SurveyForm isAffiliate={isAffiliate} />
        </div>
      </div>
    </section>
  );
}